<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>小区统计</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="搜索小区名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <!-- <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'regex:nhName|string#or': searchValue,
                'is:_id.city|string#and': city,
                'is:_id.district|string#and': district,
                'is:subdistrict|string#and': subdistrict,
                'in:_id.leakagesite|array#and': leakagesite.join(),
                'gte:_id.date|string#and': dateRange ? dateRange[0].split(' ')[0] : null,
                'lte:_id.date|string#and': dateRange ? dateRange[1].split(' ')[0] : null,
                sortField: sortField,
                sortOrder: sortOrder,
                beanName: 'mb_stat_neighborhood',
                title: '小区统计'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button> -->
      </div>
    </div>
    <div class="filters">
      <div class="filter">
        <div class="filter-label">小区位置</div>
        <div class="filter-area">
          <div>
            <span
              @click="cityClick('')"
              :class="city == '' ? 'c-blue filter-item' : ' filter-item'"
            >
              全部
            </span>
            <span
              @click="cityClick('110100')"
              :class="city == '110100' ? 'c-blue filter-item' : ' filter-item'"
            >
              北京
            </span>
            <span
              @click="cityClick('310100')"
              :class="city == '310100' ? 'c-blue filter-item' : ' filter-item'"
            >
              上海
            </span>
          </div>
          <div v-if="city">
            <span
              v-for="(item, i) in districts"
              :key="i"
              @click="districtClick(item.value)"
              :class="district == item.value ? 'c-blue filter-item' : 'filter-item'"
            >
              {{ item.label }}
            </span>
          </div>
          <div v-if="district">
            <span v-for="(value, key) in subdistrictGroup" :key="key">
              <span class="firstLetter">{{ key }}</span>
              <span
                v-for="(item, i) in value"
                :key="i"
                @click="subdistrictClick(item.value)"
                :class="subdistrict == item.value ? 'c-blue filter-item' : 'filter-item'"
              >
                {{ item.label }}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div class="filter">
        <div class="filter-label">渗漏部位</div>
        <el-checkbox-group v-model="leakagesite" @change="filter()" class="filter-checkbox">
          <el-checkbox v-for="(item, i) in options.partsOne" :key="i" :label="item.value">
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="filter">
        <div class="filter-label">统计日期</div>
        <div class="c-flex-1 c-flex c-flex-between">
          <el-date-picker
            style="width: 250px"
            v-model="dateRange"
            type="daterange"
            :picker-options="date.pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="mini"
            @change="filter()"
          ></el-date-picker>
          <div
            v-if="city || leakagesite.length > 0 || dateRange"
            class="filter-clear"
            @click="clearFilter"
          >
            <i class="el-icon-brush"></i>
            清空过滤条件
          </div>
        </div>
      </div>
    </div>
    <div class="sort">
      <div @click="sortClick('default')" :class="sortField == 'default' ? 'active' : ''">
        默认排序
      </div>
      <div @click="sortClick('lcount')" :class="sortField == 'lcount' ? 'active' : ''">
        线索数
        <i
          v-if="sortField == 'lcount'"
          :class="sortOrder == 'desc' ? 'el-icon-bottom' : 'el-icon-top'"
          style="font-weight: 900;"
        ></i>
      </div>
      <div @click="sortClick('scount')" :class="sortField == 'scount' ? 'active' : ''">
        工单数
        <i
          v-if="sortField == 'scount'"
          :class="sortOrder == 'desc' ? 'el-icon-bottom' : 'el-icon-top'"
          style="font-weight: 900;"
        ></i>
      </div>
      <div @click="sortClick('ccount')" :class="sortField == 'ccount' ? 'active' : ''">
        合同数
        <i
          v-if="sortField == 'ccount'"
          :class="sortOrder == 'desc' ? 'el-icon-bottom' : 'el-icon-top'"
          style="font-weight: 900;"
        ></i>
      </div>
      <div @click="sortClick('ccamount')" :class="sortField == 'ccamount' ? 'active' : ''">
        合同总金额
        <i
          v-if="sortField == 'ccamount'"
          :class="sortOrder == 'desc' ? 'el-icon-bottom' : 'el-icon-top'"
          style="font-weight: 900;"
        ></i>
      </div>
      <div @click="sortClick('perPrice')" :class="sortField == 'perPrice' ? 'active' : ''">
        客单价
        <i
          v-if="sortField == 'perPrice'"
          :class="sortOrder == 'desc' ? 'el-icon-bottom' : 'el-icon-top'"
          style="font-weight: 900;"
        ></i>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          @header-dragend="osg.colWidthChange"
          :row-class-name="osg.lastRowClassName"
        >
          <!-- 
            _id.date
            _id.leakagesite - 部位编码
            _id.nhId - 小区id
            _id.city
            _id.district
            _id.province
            leakagesite - 部位名称
            lcount - 线索数
            scount - 工单数
            ccount - 合同数
            ccamount - 合同总金额
            sccount - 当天工单关联的所有合同数
            scamount - 当天工单关联的所有合同总金额
            scucount - 当天有合同的工单数
          -->
          <el-table-column label="小区名称" width="220px" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                type="text"
                class="c_size_14 c-font-bold"
                @click="
                  $router.push({
                    path: `/Neighborhood/${scope.row._id}`
                  })
                "
              >
                {{ scope.row.nhName }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="小区位置" width="220px">
            <template slot-scope="scope">
              <span class="c_size_14">
                <span v-if="scope.row.provinceStr">{{ scope.row.provinceStr }}/</span>
                <span v-if="scope.row.cityStr && scope.row.cityStr != '市辖区'">
                  {{ scope.row.cityStr }}/
                </span>
                <span v-if="scope.row.districtStr">{{ scope.row.districtStr }}/</span>
                <span v-if="scope.row.subdistrictStr">{{ scope.row.subdistrictStr }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="线索数" header-align="center" align="center">
            <template slot-scope="scope">
              <span class="c_size_18 c-font-bold" style="vertical-align: middle;">
                {{ scope.row.lcount }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="工单数" header-align="center" align="center">
            <template slot-scope="scope">
              <span class="c_size_18 c-font-bold" style="vertical-align: middle;">
                {{ scope.row.scount }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="合同数" header-align="center" align="center">
            <template slot-scope="scope">
              <span class="c_size_18 c-font-bold" style="vertical-align: middle;">
                {{ scope.row.ccount }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="合同总金额" header-align="center" align="center">
            <template slot-scope="scope">
              <span class="c_size_18 c-font-bold c_red" style="vertical-align: middle;">
                {{ scope.row.ccamount }}
                <span class="c_size_12">元</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="客单价" header-align="center" align="center">
            <template slot-scope="scope">
              <span class="c_size_18 c-font-bold c_red" style="vertical-align: middle;">
                {{ scope.row.perPrice }}
                <span class="c_size_12">元</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import pinyin from 'pinyin';
export default {
  activated() {
    window.$this = this;
  },
  data() {
    window.$this = this;
    return {
      tenantId: '',
      name: 'neighborhood',
      fpi: { page: 1, rows: 20 },
      searchValue: '',
      openDetail: false,
      formData: { exts: {} },
      extFields: [],
      extField: {},
      rules: this.$util.rules,
      options: {
        codecfg_partsOne: {
          codeId: 'partsOne'
        },
        partsOne: []
      },
      area: {
        options: this.osg.areaList
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      districts: [],
      subdistrictGroup: {},
      city: '',
      district: '',
      subdistrict: '',
      leakagesite: [],
      dateRange: '',
      sortField: 'default',
      sortOrder: 'desc'
    };
  },
  async mounted() {
    this.doInit();
    this.osg.getFields('neighborhood', () => {
      this.options.partsOne.push({ label: '厨房', value: '7' });
      this.osg.getFpi();
      this.fpi.page = 1;
      this.fpi.rows = 20;
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
    },
    filter() {
      this.fpi.page = 1;
      this.getData();
    },
    getData() {
      this.osg.setFpi();
      // 处理$match过滤
      let params = {};
      if (this.searchValue) params['nhName'] = { $regex: this.searchValue };
      if (this.province) params['_id.province'] = this.province;
      if (this.city) params['_id.city'] = this.city;
      if (this.district) params['_id.district'] = this.district;
      if (this.subdistrict) params['subdistrict'] = this.subdistrict;
      if (this.leakagesite.length > 0) params['_id.leakagesite'] = { $in: this.leakagesite };
      if (this.dateRange)
        params['_id.date'] = {
          $gte: this.dateRange[0].split(' ')[0],
          $lte: this.dateRange[1].split(' ')[0]
        };
      // 处理$sort排序
      let sort = {};
      if (this.sortField == 'default') {
        sort = {
          date: -1,
          '_id.nhId': 1
        };
      } else {
        sort[this.sortField] = this.sortOrder == 'desc' ? -1 : 1;
      }
      this.osg.ajax(
        'stat/aggr/mb_stat_neighborhood.do',
        {
          aggr: JSON.stringify([
            {
              $match: params
            },
            {
              $group: {
                _id: '$_id.nhId',
                lcount: { $sum: '$lcount' },
                scount: { $sum: '$scount' },
                ccount: { $sum: '$ccount' },
                ccamount: { $sum: '$ccamount' }
              }
            },
            {
              $addFields: {
                ccamount: { $round: ['$ccamount', 0] }, // 四舍五入取整,
                perPrice: {
                  $cond: {
                    if: { $ne: ['$ccount', 0] },
                    then: { $round: [{ $divide: ['$ccamount', '$ccount'] }, 0] }, // 四舍五入取整,
                    else: 0
                  }
                }
              }
            },
            {
              $lookup: {
                from: 'neighborhood',
                let: { nhId: '$_id' },
                pipeline: [
                  {
                    $match: { $expr: { $eq: ['$_id', '$$nhId'] } }
                  }
                ],
                as: 'nhData'
              }
            },
            {
              $unwind: { path: '$nhData', preserveNullAndEmptyArrays: true }
            },
            {
              $facet: {
                data: [
                  {
                    $project: {
                      _id: '$_id',
                      lcount: '$lcount',
                      scount: '$scount',
                      ccount: '$ccount',
                      ccamount: '$ccamount',
                      perPrice: '$perPrice',
                      nhName: '$nhData.name',
                      provinceStr: '$nhData.provinceStr',
                      cityStr: '$nhData.cityStr',
                      districtStr: '$nhData.districtStr',
                      subdistrictStr: '$nhData.subdistrictStr'
                    }
                  },
                  { $sort: sort },
                  { $skip: this.fpi.rows * (this.fpi.page - 1) },
                  { $limit: this.fpi.rows }
                ],
                total: [
                  // 这里计算总记录数
                  { $count: 'count' }
                ]
              }
            },
            {
              $project: {
                data: 1,
                total: { $arrayElemAt: ['$total.count', 0] } // 提取 total 的值
              }
            }
          ])
        },
        res => {
          this.fpi.data = res[0].data;
          this.fpi.total = res[0].total;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    async cityClick(code) {
      this.district = '';
      this.subdistrict = '';
      if (this.city == code) {
        this.filter();
      } else {
        this.city = code;
        this.filter();
        if (this.city) this.districts = await this.$util.getDistrict(code);
      }
    },
    async districtClick(code) {
      this.subdistrict = '';
      if (this.district == code) {
        this.filter();
      } else {
        this.district = code;
        this.filter();

        let subdistricts = await this.$util.getSubdistrict(code, null, null, true);
        // 排序
        subdistricts.sort((a, b) => a.label.localeCompare(b.label, 'zh-CN'));
        // 存储分组结果
        let group = {};
        // 分组
        subdistricts.forEach(subdistrict => {
          // 使用 pinyin 获取第一个汉字的拼音首字母
          const firstLetter = pinyin(subdistrict.label[0], {
            style: pinyin.STYLE_FIRST_LETTER
          })[0][0].toUpperCase();
          // 如果该首字母在结果对象中还没有，则初始化为一个空数组
          if (!group[firstLetter]) {
            group[firstLetter] = [];
          }
          // 将当前的 label 加入对应首字母的数组
          group[firstLetter].push(subdistrict);
        });
        this.subdistrictGroup = group;
      }
    },
    subdistrictClick(code) {
      this.subdistrict = code;
      this.filter();
    },
    clearFilter() {
      this.city = '';
      this.district = '';
      this.subdistrict = '';
      this.leakagesite = [];
      this.dateRange = '';
      this.filter();
    },
    sortClick(sortField) {
      if (this.sortField == 'default' && sortField == 'default') {
        // 重复点击默认排序
        return;
      } else if (this.sortField == sortField) {
        this.sortOrder = this.sortOrder == 'desc' ? 'asc' : 'desc';
      } else {
        this.sortField = sortField;
        this.sortOrder = 'desc';
      }
      this.filter();
    }
  }
};
</script>
<style lang="scss" scoped>
.filters {
  font-size: 12px;
  background-color: #fbfbfb;
  margin: 10px 0;
  padding: 15px;
  border-radius: 8px;
  .filter {
    display: flex;
    line-height: 27px;
    margin-top: 10px;
    &:first-of-type {
      margin-top: 0;
    }
    .filter-label {
      width: 70px;
      min-width: 70px;
      font-weight: 700;
    }
    .filter-area {
      .filter-item {
        margin-right: 15px;
        line-height: 27px;
        cursor: pointer;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
      .firstLetter {
        margin-right: 5px;
        font-weight: 700;
      }
    }
    .filter-checkbox {
      display: flex;
      flex-wrap: wrap;
      .el-checkbox {
        font-weight: normal;
        color: #2c3e50;
        ::v-deep .el-checkbox__label {
          font-size: 12px;
        }
      }
    }
  }
  .filter-clear {
    cursor: pointer;
    &:hover {
      color: #409eff;
    }
  }
}
.sort {
  display: flex;
  border-bottom: 2px solid #409eff;
  margin-bottom: 30px;
  > div {
    width: 110px;
    height: 45px;
    text-align: center;
    line-height: 45px;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    &.active {
      color: #fff;
      background-color: #409eff;
    }
  }
}
</style>
